export default __webpack_public_path__ + "static/media/1732.04f069a3.png";